import { render, staticRenderFns } from "./TodayDashboard.vue?vue&type=template&id=4cd9822a&scoped=true&"
import script from "./TodayDashboard.vue?vue&type=script&lang=js&"
export * from "./TodayDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TodayDashboard.vue?vue&type=style&index=0&id=4cd9822a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd9822a",
  null
  
)

export default component.exports